// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"c1722ea3","195":"ac795f8d","232":"1fbb4e8d","266":"8c881fad","538":"ebdd8ac4","787":"d8c6ec95"}[chunkId] + ".chunk.js";
};